/**
 * Helper de cliente HTTP para el CMS.
 * Envía automáticamente el JWT guardado en localStorage como header Authorization.
 * central de manejo de errores 401 (sesión expirada).
 *
 * Uso:
 *   import { apiFetch } from '@/utils/api';
 *   const res = await apiFetch('/api/branches');
 *   if (res.status) { ... res.data ... }
 */

function getToken() {
  return localStorage.getItem('auth_token');
}

export function setToken(token) {
  localStorage.setItem('auth_token', token);
}

export function clearToken() {
  localStorage.removeItem('auth_token');
  localStorage.setItem('isLoggedIn', 'false');
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    ...(options.headers || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // No establecer Content-Type para FormData (lo hace el navegador con boundary)
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }

  const res = await fetch(path, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    clearToken();
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    throw new Error('Sesión expirada');
  }

  const data = await res.json().catch(() => ({}));
  return data;
}

export default apiFetch;